import { Box, Divider, ThemeProvider, Typography } from "@mui/material";
import HeaderBox from "../../../../components/shared/boxes/HeaderBox";
import Filters from "./filters/Filters";
import ProduttivoMuiThemeV2 from "../../../../components/shared/themes/ProduttivoThemeV2";
import { useEffect, useRef } from "react";
import { applyWindowformFillsFilters, buildExportFilters, buildQueryParams } from "../../../helpers/filtersHelpers";

const FiltersContainer = ({ accountId, dateFilterRange }) => {
  const currentFiltersRef = useRef({});

  const executeScripts = (container) => {
    const scripts = container.querySelectorAll("script");
    scripts.forEach((oldScript) => {
      const newScript = document.createElement("script");
      Array.from(oldScript.attributes).forEach(attr =>
        newScript.setAttribute(attr.name, attr.value)
      );
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  };

  const fetchFrame = (url, viewType) => {
    const frame = document.getElementById("form_fills_content");
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    frame.style.opacity = "0.4";
    frame.style.pointerEvents = "none";

    fetch(url, {
      headers: {
        "Turbo-Frame": "form_fills_content",
        "Accept": "text/html, application/xhtml+xml",
        "X-CSRF-Token": csrfToken
      }
    })
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newFrame = doc.getElementById("form_fills_content");
        if (newFrame) {
          frame.innerHTML = newFrame.innerHTML;
          executeScripts(frame);
        }
        const currentModal = document.getElementById("tableFieldsModal");
        const newModal = doc.getElementById("tableFieldsModal");

        if (currentModal && newModal) {
          currentModal.replaceWith(newModal);
        }

        if (viewType === "map_view") {
          loadMap();
        }
        requestAnimationFrame(() => {
          if (typeof initTableScroll === "function") {
            initTableScroll();
          }
        });
      })
      .catch(err => console.error("Erro ao buscar frame:", err))
      .finally(() => {
        frame.style.opacity = "1";
        frame.style.pointerEvents = "auto";
      });

    window.history.replaceState(null, "", url);
  };

  useEffect(() => {
    const handleViewToggleClick = (e) => {
      const button = e.target.closest("button.button-report-toggle");
      if (!button) return;

      document.querySelectorAll("button.button-report-toggle").forEach(btn => {
        btn.classList.remove("button-report-toggle-selected");
      });
      button.classList.add("button-report-toggle-selected");

      const viewType = button.dataset.viewType;

      const params = new URLSearchParams(window.location.search);
      params.set("view_type", viewType);

      const url = `/form_fills?${params.toString()}`;

      const filters = currentFiltersRef.current;
      const hasOneForm = filters.formIds?.length === 1;
      const isTableView = viewType === 'table_view';

      const columnsBtn = document.getElementById("table_fields_button");
      if (columnsBtn) columnsBtn.disabled = !hasOneForm || !isTableView;

      fetchFrame(url, viewType);
    };

    document.addEventListener("click", handleViewToggleClick);
    return () => document.removeEventListener("click", handleViewToggleClick);
  }, []);

  useEffect(() => {
    const handleExportClick = (e) => {
      if (!e.target.closest("#export_all_form_fills_button")) return;

      const filters = currentFiltersRef.current;
      const exportFilters = buildExportFilters(filters);

      window.showExportModal(exportFilters, null);
    };

    const handleColumnsClick = (e) => {
      if (!e.target.closest("#table_fields_button")) return;

      showTableFieldsModal();
    };

    document.addEventListener("click", handleExportClick);
    document.addEventListener("click", handleColumnsClick);

    return () => {
      document.removeEventListener("click", handleExportClick);
      document.removeEventListener("click", handleColumnsClick);
    };
  }, []);

  const applyFilters = (filters) => {
    currentFiltersRef.current = filters;

    applyWindowformFillsFilters(filters);

    if (filters.formIds?.length === 1) {
      if (typeof updateFieldsForSort === "function") {
        updateFieldsForSort(filters.formIds[0]);
      }
    }

    const isTableView = new URLSearchParams(window.location.search).get('view_type') !== 'map_view'
      && new URLSearchParams(window.location.search).get('view_type') !== 'card_view';

    const exportBtn = document.getElementById("export_all_form_fills_button");
    const columnsBtn = document.getElementById("table_fields_button");
    const hasOneForm = filters.formIds?.length === 1;

    if (exportBtn) exportBtn.disabled = !hasOneForm;
    if (columnsBtn) columnsBtn.disabled = !hasOneForm || !isTableView;

    const query = buildQueryParams(filters);
    const url = `/form_fills?${query}`;
    const viewType = new URLSearchParams(window.location.search).get("view_type");

    fetchFrame(url, viewType);
  };

  return (
    <>
      <Box sx={{ bgcolor: 'background.header' }}>
        <HeaderBox>
          <Typography variant="h3">Preenchimentos Realizados / Relatórios</Typography>
          <Divider sx={{ m: '2rem 0' }} />
          <ThemeProvider theme={ProduttivoMuiThemeV2}>
            <Filters
              applyFilterCallback={applyFilters}
              accountId={accountId}
              dateFilterRange={dateFilterRange}
            />
          </ThemeProvider>
        </HeaderBox>
      </Box>
    </>
  );
}

export default FiltersContainer;